import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoFoodIcon(props: IconProps) {
    return <Icon {...props} iconKey={"no_food"}/>
}
